import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--license-example-copy"
export default class extends Controller {
  static targets = ["container", "template"];

  connect() {}

  copy(e) {
    e.preventDefault();

    this._licenseFiilable(e);
  }

  _licenseFiilable(e) {
    const name = e.currentTarget.dataset["resumin-LicenseExampleCopyNameValue"];
    const container = this.containerTarget;
    const lists = container.querySelectorAll(
      "li[data-resumin--license-example-copy-target='template']"
    );
    if (lists.length <= 0) {
      return;
    }

    e.target.classList.add("is-selected");

    const lastList = lists[lists.length - 1];
    const targetList = this._anyTextFieldFilled(lastList)
      ? this._addList(e)
      : lastList;

    const field = targetList.querySelector(
      "[data-resumin--license-example-copy-target='field']"
    );
    field.value = name;
    field.dispatchEvent(new Event("input", { bubbles: true }));
    this._scrollToField(field);
    field.focus();

    setTimeout(() => {
      e.target.classList.remove("is-selected");
    }, 2000);
  }

  _anyTextFieldFilled(lastList) {
    const inputs = Array.from(lastList.querySelectorAll("input[type='text']"));

    return inputs.some((input) => input.value.trim() !== "");
  }

  _addList(e) {
    const controller = this._getAdditionController();
    return controller.add(e);
  }

  _getAdditionController() {
    const controllerElement = document.querySelector(
      "[data-controller~='resumin--form-addition']"
    );
    return this.application.getControllerForElementAndIdentifier(
      controllerElement,
      "resumin--form-addition"
    );
  }

  _scrollToField(el) {
    if (!el) return;

    const targetY = el.getBoundingClientRect().top;
    const startY = window.pageYOffset;
    const distance = targetY - startY;
    const startTime = performance.now();
    const duration = 900;

    const step = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease =
        progress < 0.5
          ? 2 * progress * progress
          : -1 + (4 - 2 * progress) * progress;

      window.scrollTo(0, startY + distance * ease);

      if (elapsed < duration) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }
}
